<div *ngIf="profile">
  <div *ngIf="!isHovered">
    <p
      *ngIf="!isProfile"
      [ngClass]="{
        'solo-text-big-statop-view': isStatopView && !tinyMode,
        'solo-text-big': !tinyMode && !isStatopView,
        'tiny-mode-solo-text-big': tinyMode,
      }"
    >
      {{ fullSpecialtiesName }}
    </p>
    <p
      *ngIf="isProfile"
      [ngClass]="{
        'solo-text-small': !tinyMode && !basicProfile,
        'solo-text-statop': !tinyMode && basicProfile,
        'tiny-mode-solo-text-small': tinyMode,
      }"
    >
      {{ fullSpecialtiesName }}
    </p>
  </div>
  <div *ngIf="isTooLong" (mouseout)="onMouseOut()" (mouseover)="onMouseOver()">
    <div *ngIf="isHovered" class="hovered">
      <div class="header">
        <p class="title">{{ hospitalNames.specialtiesName }}s</p>
      </div>
      <div class="content">
        <div fxLayout="column" fxLayoutAlign="start start">
          <div *ngFor="let specialtyName of specialtiesName" class="text-header">
            <p class="text">{{ specialtyName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
